module.exports = __webpack_public_path__ + "img/cxwk-xr.7dd633b7.png";